module.exports = __webpack_public_path__ + "static/assets/368c582b289e75a3c5299e954c2ad735.ttf";